export const pluginFileName = (version: string): string =>
  `and-digital-claude-plugins-${version}.zip`;

export const MARKETPLACE_DIR = '~/.claude/marketplaces';
/** Assumed, not known: a browser never tells the page where it saved the file. */
export const DOWNLOADS_DIR = '~/Downloads';
export const MARKETPLACE_NAME = 'and-digital-claude-plugins';
/** The name claude.ai gives the GitLab-synced copy of the same repository. */
export const ORG_MARKETPLACE_NAME =
  'claudeai-and-digital-group-ai-augment-and-digital-claude-plugins';

export const COMMAND_FORMS = [
  { value: 'shell', label: 'Shell' },
  { value: 'claude', label: 'Claude Code' },
] as const;

export type CommandForm = (typeof COMMAND_FORMS)[number]['value'];
